module.exports = __webpack_public_path__ + "img/zhizhen.8baff206.png";